<template>
  <div :class="{ 'speaker-section mb-10': true }">
    <h3
      :class="{
        'pb-18px text-13px font-extrabold uppercase leading-none tracking-[2.08px] text-www-color-accent': true,
        'before:relative before:-top-1 before:left-0 before:mr-10px before:inline-block before:h-2px before:w-25px before:bg-www-color-accent before:content-[\'\']': true,
      }"
    >
      {{ label }}
    </h3>
    <div
      v-for="(item, index) in props.speaker"
      :key="index"
    >
      <Speaker
        v-if="item"
        :speaker="item"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { SpeakerSection } from '~/sanity/types';
import Speaker from './Speaker.vue';
const props = defineProps<SpeakerSection>();
</script>
